var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-view',{attrs:{"name":"user_header"}}),_c('router-view',{staticClass:"min-vh-100",attrs:{"value_new":_vm.value_new,"target_company_name":_vm.target_company_name}}),_c('router-view',{attrs:{"name":"user_footer"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }